<template>
    <div class="form">
        <ValidationObserver ref="form">
            <h2 class="profile__title">REPERTOIRE</h2>
            <ValidationProvider
                class="form-group"
                name="Title"
                v-slot="{ errors }"
                rules="required|min:2|max:100"
            >
                <label for="" class="form-label">Title*</label>
                <input
                    type="text"
                    class="form-control pl-4"
                    v-model="repertoireInformation.title"
                >
                <FormError
                    :error="errors[0]"
                    name="Title"
                ></FormError>
            </ValidationProvider>

            <ValidationProvider
                class="form-group"
                name="Description"
                v-slot="{ errors }"
                rules="required|min:2|max:1000"
            >
                <label for="" class="form-label">Description*</label>
                <textarea
                    class="form-control pl-4"
                    v-model="repertoireInformation.description"
                ></textarea>
                <FormError
                    :error="errors[0]"
                    name="Description"
                ></FormError>
            </ValidationProvider>

            <h2 class="profile__title">SHOW</h2>

            <ShowForm
                v-for="(show, index) in repertoireInformation.shows"
                :key="`${index} - show`"
                :show="show"
                :index="index"
                :is-active="index === activeShow"
                @data-changed="updateInformation"
                @activate="activateForm('activeShow', index)"
                @saveShowForm="closeForm('activeShow')"
                @removeShow="deleteForm"
            />

            <div class="form-group mb-5" v-if="repertoireInformation.shows.length === 0 && isPermission">
                <a
                    href="javascript:void(0)"
                    class="btn btn_primary-outline w-100"
                    @click="addNewShow"
                >Add New Show</a>
            </div>

            <div class="add-link mb-3" v-if="repertoireInformation.quotes.length > 0 && isPermission">
                <a href="javascript:void(0)" @click="addNewShow">+ Add Show</a>
            </div>


            <h2 class="profile__title">quotes</h2>

            <QuoteForm
                v-for="(quote, index) in repertoireInformation.quotes"
                :key="`${index} - quote`"
                :quote="quote"
                :index="index"
                :is-active="index === activeQuote"
                @activate="activateForm('activeQuote', index)"
                @saveQuoteForm="closeForm('activeQuote')"
                @removeQuote="deleteForm"
                @data-changed="updateInformation"
            />

            <div class="form-group mb-5" v-if="repertoireInformation.quotes.length === 0 && isPermission">
                <a
                    href="javascript:void(0)"
                    class="btn btn_primary-outline w-100"
                    @click="addNewQuote"
                >Add New Quote</a>
            </div>

            <div class="add-link mb-5" v-if="repertoireInformation.quotes.length > 0 && isPermission">
                <a href="javascript:void(0)" @click="addNewQuote">+ Add Quote</a>
            </div>


            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <button
                            type="reset"
                            class="btn btn_primary-outline pl-5 pr-5"
                        >
                            <span>Cancel</span>
                        </button>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group text-right">
                        <button
                            v-if="isPermission"
                            class="btn btn_golden"
                            @click="validate"
                        >
                            <span class="pl-5 pr-5">Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>


</template>


<script>
import ShowForm from "./ShowForm.vue";
import QuoteForm from "./QuoteForm.vue";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import FormError from "../Common/FormError.vue";
import ArtistService from "../../services/ArtistService";
import BaseButtons from "../Common/BaseButtons.vue";

export default {
    name: 'ArtistShows',
    components: {BaseButtons, FormError, QuoteForm, ShowForm},
    computed: {
        ...mapState(useArtistStore, {
            repertoireInformation: 'repertoireInformation',
            artistId: 'artistId'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },
    data() {
        return {
            activeShow: null,
            activeQuote: null,
        }
    },
    props: {
        adminType: String
    },
    methods: {
        addNewShow() {
            this.repertoireInformation.shows.push({
                show_title: null,
                show_duration: null,
                show_description: null
            });

            this.activeShow = this.repertoireInformation.shows.length - 1;
        },
        addNewQuote() {
            this.repertoireInformation.quotes.push({
                author_name: null,
                quote_resource: null,
                quote_description: null
            });

            this.activeQuote = this.repertoireInformation.quotes.length - 1;
        },
        activateForm(type, index) {
            this[type] = index;
        },
        closeForm(form) {
            this[form] = null
        },
        deleteForm(info) {
            this.repertoireInformation[info.type].splice(info.index, 1)
        },
        updateInformation(result, type) {
            this.repertoireInformation[type].splice(result.index, 1, result);
        },
        async validate() {
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage();
            } else {
                await this.updateArtistShows();
            }
        },
        async updateArtistShows() {
            try {
                await ArtistService.updateShowsArtistInfo(this.artistId, this.repertoireInformation);
                this.$showSuccessMessage('Profile was successfully updated')
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated')
            }
        },
    },
}

</script>


<style scoped>

</style>
